package io.daio.pancake.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp

val Icons.FeedOutline: ImageVector
    get() {
        if (_FeedOutline != null) {
            return _FeedOutline!!
        }
        _FeedOutline = ImageVector.Builder(
            name = "FeedOutline",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(
                fill = SolidColor(Color(0xFFFFFFFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(5.5f, 5.5f)
                horizontalLineToRelative(13f)
                verticalLineToRelative(8f)
                horizontalLineToRelative(-13f)
                verticalLineToRelative(-8f)
                close()
                moveTo(4f, 4f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(11f)
                lineTo(4f, 15f)
                lineTo(4f, 4f)
                close()
                moveTo(4.5f, 17.75f)
                horizontalLineToRelative(15f)
                verticalLineToRelative(-1.5f)
                horizontalLineToRelative(-15f)
                verticalLineToRelative(1.5f)
                close()
                moveTo(6f, 20.25f)
                horizontalLineToRelative(12.5f)
                verticalLineToRelative(-1.5f)
                lineTo(6f, 18.75f)
                verticalLineToRelative(1.5f)
                close()
            }
        }.build()

        return _FeedOutline!!
    }

@Suppress("ObjectPropertyName")
private var _FeedOutline: ImageVector? = null
